import api, { apiWithToken } from './api';
import { API_ENDPOINTS } from '../config/apiUrls';
import { decodeData } from '../helpers/function_helper';

export const authService = {
  // Đăng nhập
  login: async (credentials) => {
    try {
      const response = await api.post(API_ENDPOINTS.LOGIN, credentials);
      return decodeData(response.data);
    } catch (error) {
      // Nếu API trả về error với data, return data đó
      if (error.response?.data) {
        return decodeData(error.response.data);
      }
      throw error;
    }
  },

  // Đăng xuất
  logout: async () => {
    try {
      const response = await apiWithToken.delete(API_ENDPOINTS.LOGOUT);
      return decodeData(response.data);
    } catch (error) {
      if (error.response?.data) {
        return decodeData(error.response.data);
      }
      throw error;
    }
  },

  // Kiểm tra token hợp lệ
  verifyToken: async (token) => {
    try {
      const response = await apiWithToken.get('/verify-token');
      return decodeData(response.data);
    } catch (error) {
      if (error.response?.data) {
        return decodeData(error.response.data);
      }
      throw error;
    }
  }
};